import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class ServiceModel extends Model {
  static reducer(action, ServiceModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Service.schema:
        action.payload.forEach((payload) => {
          const dbData = ServiceModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ServiceModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ServiceModel.modelName = "ServiceModel";

ServiceModel.fields = {
  id: attr(),
};

export default ServiceModel;